require('angular');		
require('angular-sanitize');
require('./videogular');

module.exports = 'com.2fdevs.videogular';



//////////////////
// WEBPACK FOOTER
// ./~/videogular/index.js
// module id = 15
// module chunks = 0